/** Number formatting shared by every screen. */

export function money(value: number, currency = 'USD', opts: { cents?: boolean } = {}): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: opts.cents ? 2 : 0,
    minimumFractionDigits: opts.cents ? 2 : 0,
  }).format(value)
}

export function count(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

/** "+12%" / "−8%" / "same", against a previous value. null when there is nothing to compare with. */
export function change(now: number, before: number): { text: string; direction: 'up' | 'down' | 'flat' } | null {
  if (before === 0) return now === 0 ? { text: 'same', direction: 'flat' } : null
  const pct = Math.round(((now - before) / before) * 100)
  if (pct === 0) return { text: 'same', direction: 'flat' }
  return { text: `${pct > 0 ? '+' : '−'}${Math.abs(pct)}%`, direction: pct > 0 ? 'up' : 'down' }
}

/** "9 am", "12 pm". */
export function hourLabel(hour: number): string {
  const h = hour % 12 === 0 ? 12 : hour % 12
  return `${h} ${hour < 12 ? 'am' : 'pm'}`
}

/** "Sunday", in a timezone (the store's) when given. */
export function weekday(iso: string, timeZone?: string): string {
  return new Date(iso).toLocaleDateString('en-US', { weekday: 'long', ...(timeZone ? { timeZone } : {}) })
}

/** "Sun 11", a short day label for charts. */
export function dayLabel(iso: string, timeZone?: string): string {
  return new Date(iso).toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', ...(timeZone ? { timeZone } : {}) })
}
